import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-playfair\",\"weight\":[\"400\",\"700\"],\"display\":\"swap\",\"preload\":false,\"fallback\":[\"Georgia\",\"serif\"],\"adjustFontFallback\":\"Times New Roman\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["FacebookPixel"] */ "/app/src/components/analytics/facebook-pixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTag"] */ "/app/src/components/analytics/google-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView"] */ "/app/src/components/analytics/posthog-pageview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieProvider"] */ "/app/src/lib/context/cookie-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
